import { IRequirementModel } from '../../../../../../../service/requirement/entity/IRequirementModel';
import { RowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuUI';
import { DefaultRowContextMenu } from '../../../../../../design/dataTable/parts/rowContextMenu/view/DefaultRowContextMenu';

export class RequirementEntityContextMenuUI<RowType> extends RowContextMenuUI<IRequirementModel> {
  constructor(contextDomain) {
    super(contextDomain);
    this.defaultContextMenu.setValue({
      Component: DefaultRowContextMenu,
      id: 'default',
      properties: {
        event: null,
        isOpened: false,
        row: null,
      },
    });
  }
}
